module.exports = __webpack_public_path__ + "img/Icon_transportacion_becas_hover.10be01f7.svg";